<template lang="pug">
tooltip(:tip="title", top)
  v-card.pa-4.brand-card(
    v-responsive="16/9",
    v-on="$listeners",
    :to="to",
    :class="active && 'brand-card-active'",
    outlined
  )
    img.brand-card-img(:src="img", :alt="title")
</template>

<script>
import Tooltip from "@/components/tools/Tooltip";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    to: {
      type: String,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Tooltip,
  },
};
</script>

<style>
.brand-card {
  transition: 0.2s;
}
.brand-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 3px 3px -2px rgba(0, 0, 0, 0.2), 0 3px 4px 0 rgba(0, 0, 0, 0.14),
    0 1px 8px 0 rgba(0, 0, 0, 0.12) !important;
  border-color: transparent;
}
.brand-card-active {
  border: 1px solid var(--v-accent-base) !important;
}
.brand-card-active::before {
  background-color: var(--v-accent-base) !important;
}
.brand-card-img {
  object-fit: contain;
  height: 100%;
  width: 100%;
}
</style>
